import request from '@/utils/request'

export function qrySessionInfo(data) {
  const params = {
    header: {
    },
    content: data
  }
  return request({
    url: '/cache/qrySessionInfo',
    method: 'post',
    data: params
  })
}